export function siteGroupPath(group: { id: number; name: string }): string {
  const name = group.name
    .trim()
    .normalize("NFKD")
    .replace(/\p{M}/gu, "")
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, "-")
    .replace(/^-|-$/g, "");
  const readableName = Array.from(name).slice(0, 80).join("").replace(/-$/, "") || "site-group";
  return `/SiteGroups/${encodeURIComponent(readableName)}-${group.id}`;
}

export function siteGroupIdFromRoute(identifier: string): number {
  if (/^[\da-f]{8}(-[\da-f]{4}){3}-[\da-f]{12}$/i.test(identifier)) {
    return 0;
  }
  const lastPart = identifier.slice(identifier.lastIndexOf("-") + 1);
  const id = /^\d+$/.test(lastPart) ? Number(lastPart) : 0;
  return Number.isSafeInteger(id) && id > 0 ? id : 0;
}
